export * as Directed from './DirectedGraph.js';
export * as Undirected from './UndirectedGraph.js';